import Vue from 'vue'
import { CommonPossibleAssayResult } from '@/api/resources/common/commonPossibleAssayResult/common-possible-assay-result-services.models'

class CommonPossibleAssayResultServices extends Vue {
    async getAllPossibleAssayResults(laboratoryId: number): Promise<CommonPossibleAssayResult[]> {
        const response = await this.axios.get(`/common/possibleAssayResult/laboratories/${laboratoryId}`)
        return response.data
    }
}

export const commonPossibleAssayResultServices = new CommonPossibleAssayResultServices()
